import { writable } from 'svelte/store';

function create_device_object() {
	const { subscribe, set, update } = writable(
		JSON.parse(sessionStorage.getItem('device_object')) || {},
	);

	return {
		set,
		subscribe,
		updateDeviceObject: (id, newProps) =>
			update((props) => {
				return { ...props, [id]: newProps };
			}),
		reset: () => set({}),
	};
}

export const device_object = create_device_object();
device_object.subscribe((val) => sessionStorage.setItem('device_object', JSON.stringify(val)));

function create_scene_object() {
	const { subscribe, set, update } = writable(
		JSON.parse(sessionStorage.getItem('scene_object')) || {},
	);

	return {
		set,
		subscribe,
		updateNewSceneObj: (newObj) =>
			update((props) => {
				return { ...newObj };
			}),
		reset: () => set({}),
	};
}

export const scene_object = create_scene_object();
scene_object.subscribe((val) => sessionStorage.setItem('scene_object', JSON.stringify(val)));

function create_temp_scheme_object() {
	const { subscribe, set, update } = writable(
		JSON.parse(sessionStorage.getItem('temp_scheme_object')) || {},
	);

	return {
		set,
		subscribe,
		update: (newProps) =>
			update((props) => {
				return { ...newProps };
			}),
		reset: () => set({}),
	};
}

export const temp_scheme_object = create_temp_scheme_object();
temp_scheme_object.subscribe((val) => sessionStorage.setItem('temp_scheme_object', JSON.stringify(val)));

function create_alarm_object() {
	const { subscribe, set, update } = writable(
		JSON.parse(sessionStorage.getItem('alarm_object')) || {},
	);

	return {
		set,
		subscribe,
		update: (id, newProps) =>
			update((props) => {
				return { ...props, [id]: newProps };
			}),
		reset: () => set({}),
	};
}

export const alarm_object = create_alarm_object();
alarm_object.subscribe((val) => sessionStorage.setItem('alarm_object', JSON.stringify(val)));

function tempSceneElement() {
	const { subscribe, set, update } = writable(
		JSON.parse(sessionStorage.getItem('temp_scene_el')) || {},
	);

	return {
		set,
		subscribe,
		updateTempELement: (act) =>
			update((props) => {
				return { ...act };
			}),
		reset: () => set({}),
	};
}

export const temp_scene_el = tempSceneElement();
temp_scene_el.subscribe((val) => sessionStorage.setItem('temp_scene_el', JSON.stringify(val)));

function tmpThermostat() {
	const { subscribe, set, update } = writable(
		JSON.parse(sessionStorage.getItem('tmp_thermostat')) || {},
	);

	return {
		set,
		subscribe,
		update: (act) =>
			update((props) => {
				return { ...act };
			}),
		reset: () => set({}),
	};
}

export const tmp_thermostat = tmpThermostat();
tmp_thermostat.subscribe((val) => sessionStorage.setItem('tmp_thermostat', JSON.stringify(val)));
